/**
 * Generato automaticamente.
 * OpenAPI
 */

export type EnumVersioneSezioneDTOTipoCompilazione =
  (typeof EnumVersioneSezioneDTOTipoCompilazione)[keyof typeof EnumVersioneSezioneDTOTipoCompilazione];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumVersioneSezioneDTOTipoCompilazione = {
  PER_MODULO: 'PER_MODULO',
  PER_DOMANDA: 'PER_DOMANDA',
} as const;
